module.exports = require("joi");


//////////////////
// WEBPACK FOOTER
// external "joi"
// module id = 1
// module chunks = 0